import { FeeByGrade } from "../../features/dashboard/types";

// Sample data for the Home page product previews. Kept separate from the admin dashboard's
// mock data so dashboard changes never alter the marketing page. The numbers agree with
// each other: absentees by section sum to the hero's absent count, and monthly fee
// collection sums to the collected total by grade.

export const TOTAL_STUDENTS = 1212;

export const absenteesBySection = [
  { section: "I-A", absent: 6 },
  { section: "I-B", absent: 8 },
  { section: "II-A", absent: 5 },
  { section: "II-B", absent: 9 },
  { section: "III-A", absent: 7 },
  { section: "III-B", absent: 4 },
  { section: "IV-A", absent: 10 },
  { section: "IV-B", absent: 5 },
  { section: "V-A", absent: 6 },
  { section: "V-B", absent: 4 },
];

export const TOTAL_ABSENT = absenteesBySection.reduce((sum, s) => sum + s.absent, 0);
export const TOTAL_PRESENT = TOTAL_STUDENTS - TOTAL_ABSENT;
export const ATTENDANCE_PCT = Math.round((TOTAL_PRESENT / TOTAL_STUDENTS) * 1000) / 10;

// Same shape as the dashboard's FeeByGrade (rupees, "due"), so the Home page can render the
// real dashboard chart component. Collected sums to ₹30.6L, matching monthly collection below.
export const feeByGrade: FeeByGrade[] = [
  { grade: "LKG", collected: 360000, due: 40000 },
  { grade: "UKG", collected: 380000, due: 60000 },
  { grade: "I", collected: 440000, due: 90000 },
  { grade: "II", collected: 410000, due: 120000 },
  { grade: "III", collected: 460000, due: 70000 },
  { grade: "IV", collected: 490000, due: 150000 },
  { grade: "V", collected: 520000, due: 80000 },
];

// ₹ in lakhs, academic year so far
export const monthlyFeeCollection = [
  { month: "Jun", amount: 6.2 },
  { month: "Jul", amount: 4.8 },
  { month: "Aug", amount: 3.1 },
  { month: "Sep", amount: 2.6 },
  { month: "Oct", amount: 4.4 },
  { month: "Nov", amount: 3.0 },
  { month: "Dec", amount: 2.7 },
  { month: "Jan", amount: 3.8 },
];

export const TOTAL_COLLECTED = Math.round(monthlyFeeCollection.reduce((sum, m) => sum + m.amount, 0) * 10) / 10;

const cumulative = (values: number[]) => {
  let running = 0;
  return values.map((v) => Math.round((running += v) * 10) / 10);
};

export const overviewStats = [
  { label: "Total Students", value: TOTAL_STUDENTS.toLocaleString("en-IN"), trend: [1120, 1135, 1150, 1168, 1180, 1195, 1204, TOTAL_STUDENTS] },
  { label: "Admissions in Progress", value: "38", trend: [12, 18, 25, 31, 22, 28, 35, 38] },
  { label: "Attendance Today", value: `${ATTENDANCE_PCT}%`, trend: [93.1, 94.0, 92.6, 95.2, 94.1, 93.8, 95.0, ATTENDANCE_PCT] },
  { label: "Fees Collected", value: `₹${TOTAL_COLLECTED}L`, trend: cumulative(monthlyFeeCollection.map((m) => m.amount)) },
];
